import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper, Typography, Button } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#F3F4F6",
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          maxWidth: 720,
          width: "100%",
          p: { xs: 3, sm: 4 },
          borderRadius: 4,
          textAlign: "center",
        }}
      >
        <HomeIcon sx={{ fontSize: 56, color: "#2563EB", mb: 2 }} />
        <Typography variant="h2" sx={{ fontWeight: 700, mb: 1 }}>
          404
        </Typography>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Oops! The page you're looking for doesn't exist.
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          It might have been moved or deleted from the warehouse system.
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#2563EB",
            textTransform: "none",
            borderRadius: 3,
            px: 3,
            py: 1.2,
          }}
          onClick={() => navigate("/")}
        >
          BACK TO HOME
        </Button>
      </Paper>
    </Box>
  );
}
